import template from './add-input.html';
class AddInputController {
  constructor() {
    this.value = null;
  }
  $onInit() {
    this.formName = `inputAddForm${Math.floor(Math.random() * 100)}`;
  }
  $onChanges() { }
  $onDestroy() { }
  add() {
    if (this.formName.$invalid) return;
    this.onAdd({ value: this.value });
    this.value = null;
  }
}

export default {
  template,
  controller: AddInputController,
  controllerAs: 'addInputVm',
  bindings: {
    onAdd: '&',
    maxNumber: '<',
    minNumber: '<',
    placeHolder: '@'
  }
};
